import React from 'react';
import { useMsal } from '@azure/msal-react';

/**
 * Component displayed when user is authenticated but not authorized (lacks required group membership)
 */
const UnauthorizedComponent: React.FC<{ message?: string }> = ({ message }) => {
  const { instance } = useMsal();
  
  const handleLogout = () => {
    instance.logoutRedirect();
  };
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        maxWidth: '500px',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <svg 
          width="64" 
          height="64" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="#dc3545" 
          strokeWidth="2" 
          style={{ marginBottom: '20px' }}
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" />
          <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
        
        <h1 style={{ 
          fontSize: '24px', 
          marginBottom: '16px',
          color: '#333'
        }}>
          Access Denied
        </h1>
        
        <p style={{ 
          fontSize: '16px', 
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.5'
        }}>
          {message || 'You do not have permission to access this application.'}
        </p>
        
        <p style={{ 
          fontSize: '14px', 
          color: '#666',
          marginBottom: '24px'
        }}>
          If you believe this is an error, please contact the AI-COE Team  or submit a support ticket via the internal helpdesk.
        </p>
        
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: '#0078d4',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            fontSize: '16px',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#106ebe'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0078d4'}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedComponent;
